export const phoneValidate = (phoneNumber) => {
  var regex = /^[0-9]{10}$/;
  if (regex.test(phoneNumber) && phoneNumber.length === 10) {
    return true;
  } else {
    return false;
  }
}
